import script from "./Generate.vue?vue&type=script&setup=true&lang=ts"
export * from "./Generate.vue?vue&type=script&setup=true&lang=ts"

import "./Generate.vue?vue&type=style&index=0&id=7e8b982e&lang=less"

const __exports__ = script;

export default __exports__